export const FETCH_BOARD = 'FETCH_BOARD'
export const FETCH_BOARD_SUCCESS = 'FETCH_BOARD_SUCCESS'
export const FETCH_BOARD_FAILURE = 'FETCH_BOARD_FAILURE'


export const CREATE_BOARD = 'CREATE_BOARD'
export const CREATE_BOARD_SUCCESS = 'CREATE_BOARD_SUCCESS'
export const CREATE_BOARD_FAILURE = 'CREATE_BOARD_FAILURE'


export const UPDATE_BOARD = 'UPDATE_BOARD'
export const UPDATE_BOARD_SUCCESS = 'UPDATE_BOARD_SUCCESS'
export const UPDATE_BOARD_FAILURE = 'UPDATE_BOARD_FAILURE'

export const DELETE_BOARD = 'DELETE_BOARD'
export const DELETE_BOARD_SUCCESS = 'DELETE_BOARD_SUCCESS'
export const DELETE_BOARD_FAILURE = 'DELETE_BOARD_FAILURE'


export const CREATE_COMMENT = 'CREATE_COMMENT'
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS'
export const CREATE_COMMENT_FAILURE = 'CREATE_COMMENT_FAILURE'

export const UPDATE_COMMENT = 'UPDATE_COMMENT'
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS'
export const UPDATE_COMMENT_FAILURE = 'UPDATE_COMMENT_FAILURE'

export const DELETE_COMMENT = 'DELETE_COMMENT'
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS'
export const DELETE_COMMENT_FAILURE = 'DELETE_COMMENT_FAILURE'


export const fetchBoard = (id) => ({
    type: FETCH_BOARD,
    payload: id
})

export const fetchBoardSuccess = (board) => ({
    type: FETCH_BOARD_SUCCESS,
    payload: board
})

export const fetchBoardFailed = (message) => ({
    type: FETCH_BOARD_FAILURE,
    payload: message
})


export const createBoard = (board) => ({
    type: CREATE_BOARD,
    payload: board
})

export const createBoardSuccess = (message) => ({
    type: CREATE_BOARD_SUCCESS,
    payload: message
})

export const createBoardFailed = (message) => ({
    type: CREATE_BOARD_FAILURE,
    payload: message
})


export const updateBoard = (board) => ({
    type: UPDATE_BOARD,
    payload: board
})

export const updateBoardSuccess = (message) => ({
    type: UPDATE_BOARD_SUCCESS,
    payload: message
})

export const updateBoardFailed = (message) => ({
    type: UPDATE_BOARD_FAILURE,
    payload: message
})


export const deleteBoard = (id) => ({
    type: DELETE_BOARD,
    payload: id
})

export const deleteBoardSuccess = (message) => ({
    type: DELETE_BOARD_SUCCESS,
    payload: message
})

export const deleteBoardFailed = (message) => ({
    type: DELETE_BOARD_FAILURE,
    payload: message
})


export const createComment = (board) => ({
    type: CREATE_COMMENT,
    payload: board
})

export const createCommentSuccess = (message) => ({
    type: CREATE_COMMENT_SUCCESS,
    payload: message
})

export const createCommentFailed = (message) => ({
    type: CREATE_COMMENT_FAILURE,
    payload: message
})

export const updateComment = (comment) => ({
    type: UPDATE_COMMENT,
    payload: comment
})

export const updateCommentSuccess = (message) => ({
    type: UPDATE_COMMENT_SUCCESS,
    payload: message
})

export const updateCommentFailed = (message) => ({
    type: UPDATE_COMMENT_FAILURE,
    payload: message
})


export const deleteComment = (id) => ({
    type: DELETE_COMMENT,
    payload: id
})

export const deleteCommentSuccess = (message) => ({
    type: DELETE_COMMENT_SUCCESS,
    payload: message
})

export const deleteCommentFailed = (message) => ({
    type: DELETE_COMMENT_FAILURE,
    payload: message
})